<template>
  <div ref="room" class="room" :class="{ active }">
    <div class="room__title" @click="handleClick">
      {{ room.name }}
      <span v-if="active" class="room__icon">-</span>
      <span v-if="!active" class="room__icon">+</span>
    </div>
    <div v-if="active" class="room__body">
      <div v-if="Object.keys(room.inventories).length" class="inventories">
        <template v-for="inventory in room.inventories" :key="inventory.slug">
          <InventoryItem :room="room" :inventory="inventory" />
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery'
import InventoryItem from './InventoryItem.vue'
import { mapWritableState } from 'pinia'
import { useStagesStore } from '../stores/stages'

export default {
  name: 'RoomItem',
  components: { InventoryItem },
  props: {
    room: {
      type: Object,
      default: null,
    },
    initCollapsed: {
      type: Boolean,
      default: false,
    },
    index: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {}
  },
  computed: {
    ...mapWritableState(useStagesStore, ['values', 'activeRoom']),
    active() {
      return this.room.id === this.activeRoom
    },
    roomObj() {
      return this.values.rooms.find((room) => room.id === this.room.id)
    },
  },
  mounted() {
    if (!this.activeRoom && this.index === 0) {
      this.activeRoom = this.room.id
    }
  },
  methods: {
    handleClick() {
      if (this.activeRoom === this.room.id) {
        this.activeRoom = null
        return
      }

      this.activeRoom = this.room.id
      const adminBarHeight = $('#wpadminbar').length
        ? $('#wpadminbar').height()
        : 0

      let offset = 15
      if (window.matchMedia('(max-width: 991.98px)').matches) {
        offset = 130
      }

      setTimeout(() => {
        $('html, body').animate(
          {
            scrollTop:
              $(this.$refs.room).offset().top - adminBarHeight - offset,
          },
          0
        )
      }, 250)
    },
  },
}
</script>

<style scoped lang="scss">
.room {
  background-color: #fff;
  border: 2px solid #fff;
  transition:
    border-color 250ms,
    background-color 250ms;
  margin-bottom: 10px;

  &:last-child {
    margin-bottom: 0;
  }

  &.active {
    background-color: transparent;
    border-color: #000;
  }

  &__title {
    display: block;
    user-select: none;
    padding: 30px;
    font-weight: 700;
    font-size: 18px;
    cursor: pointer;
    position: relative;
  }

  &__icon {
    position: absolute;
    right: 30px;
    top: 50%;
    transform: translateY(-50%);
    font-size: 24px;
    line-height: 1;
  }

  &__body {
    padding: 0 30px 30px 30px;
  }
}

.inventories {
  display: grid;
  gap: 20px;
  grid-template-columns: repeat(4, minMax(0, 1fr));

  @media (max-width: 1500px) {
    gap: 15px;
  }

  @include media-breakpoint-down(xxl) {
    grid-template-columns: repeat(3, 1fr);
  }

  @include media-breakpoint-down(xl) {
    grid-template-columns: repeat(2, 1fr);
  }

  @include media-breakpoint-down(lg) {
    grid-template-columns: repeat(1, 1fr);
  }
}
</style>
